<template>
  <div class="package-cover-banner">
    <PackageCover
      :packageStyle="package.style"
      :size="64"
      :border-radius="8"
    />
    <div class="package-cover-banner__left">
      <div class="package-cover-banner__left__title">
        <span
          ref="titleText"
          class="package-cover-banner__left__title__text"
        >
          {{ package.name }}
        </span>
      </div>
      <ProgressBar
        class="package-cover-banner__left__progress"
        :value="package.cardCountLearned ?? 0"
        :max="package.cardCount"
        color="green"
        height="16px"
      ></ProgressBar>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProgressBar from '@/components/basic/trivial/ProgressBar.vue'
import { onMounted, ref } from 'vue'
import type { PackageBasic } from '@/api/package-source'
import PackageCover from '@/components/business/package/PackageCover.vue'

defineProps<{
  package: PackageBasic
}>()

const titleText = ref(null)

onMounted(() => {
  if (titleText.value) {
    const element = titleText.value as HTMLElement
    const lineHeight = parseInt(window.getComputedStyle(element).lineHeight)
    const height = element.offsetHeight
    if (height > lineHeight * 1.5) {
      element.classList.add('is-twoline')
    }
  }
})
</script>

<style scoped>
.package-cover-banner {
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 8px 8px 11px 8px;
  gap: 12px;
  align-items: stretch;
  overflow: hidden;

  border-radius: 8px;
  background: #fff;
  box-shadow:
    0px -3px 0px 0px #eef3fd inset,
    0px 2px 0px 0px rgba(0, 0, 0, 0.1);
}

.package-cover-banner__left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 4px;
  padding-bottom: 4px;
  flex: 1;
}

.package-cover-banner__left__title {
  display: flex;
  flex-direction: column;
  width: 100%;

  color: #43536c;
  font-family: 'PingFang SC';
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}

.package-cover-banner__left__title__text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
}

.package-cover-banner__left__title__text.is-twoline {
  font-size: 0.8em; /* 两行时字体稍微变小 */
}

.package-cover-banner__left__progress {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
